import { FontConfig } from "../types"

export const HEADING_5_CONFIG: FontConfig = {
  title: "Headings/h5",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 16, tw: "text-[16px]" },
    lineHeight: { px: 24, tw: "leading-[24px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 24, tw: "text-[24px]" },
    lineHeight: { px: 36, tw: "leading-[36px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Bold", tw: "font-bold" },
    size: { px: 32, tw: "text-[32px]" },
    lineHeight: { px: 48, tw: "leading-[48px]" },
  },
}
